import React, { Suspense } from "react";
import Loader from "./components/Loader/Loader";
import CategoryViewSkeleton from "./pages/Category/CategoryViewSkeleton";

// import AdvertiseDetail from "./pages/AdvertiseDetail/DetailOrder";

const DefaultPage = React.lazy(() =>
  import("./pages/DefaultPage/Default Page")
);
const LoginStepOne = React.lazy(() => import("./pages/login/LoginStepOne"));
const LoginStepThird = React.lazy(() => import("./pages/login/LoginStepThird"));
const LoginStepTwo = React.lazy(() => import("./pages/login/LoginStepTwo"));
const Test = React.lazy(() => import("./pages/login/Test"));
const CheckInvitation = React.lazy(() => import("./pages/login/CheckInvitation"));
const ChoosLocationPage = React.lazy(() =>
  import("./pages/RegisterAD/ChoosLocationPage")
);
const TermsAndConditions = React.lazy(() =>
  import("./pages/TermsAndConditions/TermsAndConditions")
);
const CategoryView = React.lazy(() => import("./pages/Category/Category"));
const SplashView = React.lazy(() => import("./pages/Splash/Splash"));
const AdsOnMap = React.lazy(() => import("./pages/AdsOnMap/AdsOnMap"));
const Wallet = React.lazy(() => import("./pages/Wallet/Wallet"));
const Houses = React.lazy(() => import("./pages/Houses/Houses"));
const RegisterAD = React.lazy(() => import("./pages/RegisterAD/RegisterAD"));
const EditProfileBusiness = React.lazy(() =>
  import("./pages/EditProfileBusiness/EditProfileBusiness")
);
const NonProperty = React.lazy(() =>
  import("./pages/NonProperty/NonProperty")
);
const CurrencyPage = React.lazy(() =>
  import("./pages/CurrencyPage/CurrencyPage")
);
const RentalAd = React.lazy(() => import("./pages/RentalAd/RentalAd"));
const Planner = React.lazy(() => import("./pages/Planner/PLanner"));
const Call = React.lazy(() => import("./pages/Call/Call"));

const NotificationsPage = React.lazy(() =>
  import("./pages/NotificationsPage/NotificationsPage")
);

const FollowPage = React.lazy(() => import("./pages/FollowPage/FollowPage"));
const AdsPage = React.lazy(() => import("./pages/AdsPage"));

const Messages = React.lazy(() => import("./pages/Messages/connect/Messages"));
const EditProfile = React.lazy(() => import("./pages/EditProfile/EditProfile"));
const Auctions = React.lazy(() => import("./pages/Auctions/Auctions"));
const AboutView = React.lazy(() => import("./pages/AboutView/AboutView"));
const FollowersPage = React.lazy(() =>
  import("./pages/FollowersPage/FollowersPage")
);
const Rewards = React.lazy(() =>
  import("./pages/Rewards/Rewards")
);
const FollowingsPage = React.lazy(() =>
  import("./pages/FollowingsPage/FollowingsPage")
);
const Shown = React.lazy(() => import("./pages/shown/shown"));

const Profile = React.lazy(() =>
  import("./pages/Profile/Profile")
);
const ProgramSettings = React.lazy(() =>
  import("./pages/ProgramSettings/ProgramSettings")
);

const BlackList = React.lazy(() => import("./pages/BlackList/BlackList"));
const SelectAds = React.lazy(() => import("./pages/SelectAds/SelectAds"));
const HelpVeeu = React.lazy(() => import("./pages/HelpVeeu/HelpVeeu"));
const ChatPage = React.lazy(() => import("./pages/Chat/ChatPage"));
const AdvertiseDetail = React.lazy(() => import("./pages/AdvertiseDetail/AdvertiseDetail"));
const LoginLocation = React.lazy(() => import("./pages/login/LoginLocation"));
const AdManagement = React.lazy(() => import("./pages/Home/AdManagement"));

const Edit = React.lazy(() => import("./pages/Home/edit"));
const EditAds = React.lazy(() => import("./pages/Home/EditAds"));
const AllADSs = React.lazy(() => import("./pages/AllADSs/AllADSs"));
const MapTest = React.lazy(() => import("./pages/MapTest"));

const CalculateCommission = React.lazy(() =>
  import("./pages/CalculateCommission/CalculateCommission")
);
const Blogs = React.lazy(() =>
  import("./pages/Blogs/Blogs")
);

const Blog = React.lazy(() =>
  import("./pages/Blog/Blog")
);

// allADSs is home page

let routes = [
  {
    path: "/Blog/:title/:id",
    element: (
      <Suspense fallback={<Loader />}>
        <Blog />
      </Suspense>
    ),
  },
  {
    path: "/Blogs",
    element: (
      <Suspense fallback={<Loader />}>
        <Blogs />
      </Suspense>
    ),
  },
  {
    path: "/SplashView",
    element: (
      <Suspense fallback={<Loader />}>
        <SplashView />
      </Suspense>
    ),
  },
  {
    path: "/AllADS",
    element: (
      <Suspense fallback={<Loader />}>
        <DefaultPage />
      </Suspense>
    ),
  },
  {
    path: "/:id?",
    element: (
      <Suspense fallback={<Loader />}>
        <AllADSs />
      </Suspense>
    ),
  },

  {
    path: "/CommissionCalculate",
    element: (
      <Suspense fallback={<Loader />}>
        <CalculateCommission />
      </Suspense>
    ),
  },
  {
    path: "/AdvertiseDetail/:id",
    element: (
      <Suspense fallback={<Loader />}>
        <AdvertiseDetail />
      </Suspense>
    ),
  },
  {
    path: "/EditAds/",
    element: (
      <Suspense fallback={<Loader />}>
        <EditAds />
      </Suspense>
    ),
  },

  {
    path: "/LoginLocation",
    element: (
      <Suspense fallback={<Loader />}>
        <LoginLocation />
      </Suspense>
    ),
  },

  {
    path: "/AdsOnMap",
    element: (
      <Suspense fallback={<Loader />}>
        <AdsOnMap />
      </Suspense>
    ),
  },
  {
    path: "/Wallet",
    element: (
      <Suspense fallback={<Loader />}>
        <Wallet />
      </Suspense>
    ),
  },
  {
    path: "/Rewards",
    element: (
      <Suspense fallback={<Loader />}>
        <Rewards />
      </Suspense>
    ),
  },
  // {
  //   path: "/property",
  //   element: (
  //     <Suspense fallback={<Loader />}>
  //       <Houses />
  //     </Suspense>
  //   ),
  // },
  // {
  //   path: "/property/:adsPrptyTypeCode",
  //   element: (
  //     <Suspense fallback={<Loader />}>
  //       <Houses />
  //     </Suspense>
  //   ),
  // },
  // {
  //   path: "/property/:adsPrptyTradeTypeCode/:adsPrptyTypeCode",
  //   element: (
  //     <Suspense fallback={<Loader />}>
  //       <Houses />
  //     </Suspense>
  //   ),
  // },
  // {
  //   path: "/property/:adsPrptyTradeTypeCode/:adsPrptyTypeCode/:id",
  //   element: (
  //     <Suspense fallback={<Loader />}>
  //       <Houses />
  //     </Suspense>
  //   ),
  // },
  {
    path: "/property/*",
    element: (
      <Suspense fallback={<Loader />}>
        <Houses />
      </Suspense>
    ),
  },
  {
    path: "/RegisterAD",
    element: (
      <Suspense fallback={<Loader />}>
        <RegisterAD />
      </Suspense>
    ),
  },
  {
    path: "/EditProfileBusiness",
    element: (
      <Suspense fallback={<Loader />}>
        <EditProfileBusiness />
      </Suspense>
    ),
  },
  // const nonPropertyGetUrl = {"buildingMaterials" : 3 , "metals":2 , "services-labor":6 , "equipment" : 5 , "machine-tools" : 4 , "architect-contractor":7 }
  {
    path: "buildingMaterials",
    element: (
      <Suspense fallback={<Loader />}>
        <NonProperty />
      </Suspense>
    ),
  },
  {
    path: "metals",
    element: (
      <Suspense fallback={<Loader />}>
        <NonProperty />
      </Suspense>
    ),
  },
  {
    path: "services-labor",
    element: (
      <Suspense fallback={<Loader />}>
        <NonProperty />
      </Suspense>
    ),
  },
  {
    path: "equipment",
    element: (
      <Suspense fallback={<Loader />}>
        <NonProperty />
      </Suspense>
    ),
  },
  {
    path: "machine-tools",
    element: (
      <Suspense fallback={<Loader />}>
        <NonProperty />
      </Suspense>
    ),
  },
  {
    path: "architect-contractor",
    element: (
      <Suspense fallback={<Loader />}>
        <NonProperty />
      </Suspense>
    ),
  },
  {
    path: "/CurrencesPage",
    element: (
      <Suspense fallback={<Loader />}>
        <CurrencyPage />
      </Suspense>
    ),
  },
  { path: "/RentalAd/:id", element: <Suspense fallback={<Loader />}><RentalAd /></Suspense> },
  {
    path: "/Planner",
    element: (
      <Suspense fallback={<Loader />}>
        <Planner />
      </Suspense>
    ),
  },
  {
    path: "/Call",
    element: (
      <Suspense fallback={<Loader />}>
        <Call />
      </Suspense>
    ),
  },

  {
    path: "/NotificationsPage",
    element: (
      <Suspense fallback={<Loader />}>
        <NotificationsPage />
      </Suspense>
    ),
  },
  {
    path: "/User/:id",
    element: (
      <Suspense fallback={<Loader />}>
        <FollowPage />
      </Suspense>
    ),
  },
  {
    path: "/Messages",
    element: (
      <Suspense fallback={<Loader />}>
        <Messages />
      </Suspense>
    ),
  },
  {
    path: "/EditProfile",
    element: (
      <Suspense fallback={<Loader />}>
        <EditProfile />
      </Suspense>
    ),
  },
  {
    path: "/Auctions",
    element: (
      <Suspense fallback={<Loader />}>
        <Auctions />
      </Suspense>
    ),
  },
  {
    path: "/Shown",
    element: (
      <Suspense fallback={<Loader />}>
        <Shown />
      </Suspense>
    ),
  },
  {
    path: "/AboutVeeu",
    element: (
      <Suspense fallback={<Loader />}>
        <AboutView />
      </Suspense>
    ),
  },
  {
    path: "/FollowersPage/:id",
    element: (
      <Suspense fallback={<Loader />}>
        <FollowersPage />
      </Suspense>
    ),
  },
  {
    path: "/FollowingsPage/:id",
    element: (
      <Suspense fallback={<Loader />}>
        <FollowingsPage />
      </Suspense>
    ),
  },
  {
    path: "/Profile",
    element: (
      <Suspense fallback={<Loader />}>
        <Profile />
      </Suspense>
    ),
  },
  {
    path: "/ProgramSettings",
    element: (
      <Suspense fallback={<Loader />}>
        <ProgramSettings />
      </Suspense>
    ),
  },

  {
    path: "/ChoosLocationPage",
    element: (
      <Suspense fallback={<Loader />}>
        <ChoosLocationPage />
      </Suspense>
    ),
  },
  {
    path: "/TermsAndConditions",
    element: (
      <Suspense fallback={<Loader />}>
        <TermsAndConditions />
      </Suspense>
    ),
  },
  {
    path: "/CategoryView",
    element: (
      <Suspense fallback={<CategoryViewSkeleton />}>
        <CategoryView />
      </Suspense>
    ),
  },
  {
    path: "/SplashView",
    element: (
      <Suspense fallback={<Loader />}>
        <SplashView />
      </Suspense>
    ),
  },
  {
    path: "/LoginThirdStep",
    element: (
      <Suspense fallback={<Loader />}>
        <LoginStepThird />
      </Suspense>
    ),
  },
  {
    path: "/LoginSecondStep",
    element: (
      <Suspense fallback={<Loader />}>
        <LoginStepTwo />
      </Suspense>
    ),
  },
  {
    path: "/test",
    element: (
      <Suspense fallback={<Loader />}>
        <Test />
      </Suspense>
    ),
  },
  {
    path: "/LoginStepOne",
    element: (
      <Suspense fallback={<Loader />}>
        <LoginStepOne />
      </Suspense>
    ),
  },
  {
    path: "/LoginStepOne/:invitationCode",
    element: (
      <Suspense fallback={<Loader />}>
        <LoginStepOne />
      </Suspense>
    ),
  },
  // {
  //   path: "/invitation/:inviterID/:invitationCode",
  //   element: (
  //     <Suspense fallback={<Loader />}>
  //       <CheckInvitation />
  //     </Suspense>
  //   ),
  // },
  {
    path: "/invitation",
    element: (
      <Suspense fallback={<Loader />}>
        <CheckInvitation />
      </Suspense>
    ),
  },
  {
    path: "/BlackList",
    element: (
      <Suspense fallback={<Loader />}>
        <BlackList />
      </Suspense>
    ),
  },
  {
    path: "/SelectAds",
    element: (
      <Suspense fallback={<Loader />}>
        <SelectAds />
      </Suspense>
    ),
  },
  {
    path: "/VeeuHelp",
    element: (
      <Suspense fallback={<Loader />}>
        <HelpVeeu />
      </Suspense>
    ),
  },
  {
    path: "/ChatPage/:id",
    element: (
      <Suspense fallback={<Loader />}>
        <ChatPage />
      </Suspense>
    ),
  },
  {
    path: "/AdManagement",
    element: (
      <Suspense fallback={<Loader />}>
        <AdManagement />
      </Suspense>
    ),
  },
  {
    path: "/Ads",
    element: (
      <Suspense fallback={<Loader />}>
        <AdsPage />
      </Suspense>
    ),
  },
  {
    path: "/Edit/:id",
    element: (
      <Suspense fallback={<Loader />}>
        <Edit />
      </Suspense>
    ),
  },
  {
    path: "/MapTest",
    element: (
      <Suspense fallback={<Loader />}>
        <MapTest />
      </Suspense>
    ),
  },

];

export default routes;
